import type { InputProps as Props } from '@ps/web-shared-components';
import { Input } from '@ps/web-shared-components';
import { serverFieldErrMsgWarning } from '@ps/web-shared-validators';
import classNames from 'clsx';
import React from 'react';
import { useForm } from 'react-final-form';

import useErrorHandling from '@swf/core/hooks/useErrorHandling';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import useDisableField from '../../hooks/useDisableField';

import { label, root } from './TextInput.scss';

interface InputProps extends Props {
  checkDisabled?: boolean;
}

const TextInput: React.FC<InputProps> = ({
  checkDisabled,
  id,
  validators,
  meta,
  recordValidator,
  ...props
}) => {
  const { error } = useWizardContext();
  const { removeError } = useErrorHandling();
  const disableField = useDisableField();
  const form = useForm();

  return (
    <Input
      {...props}
      {...(!error && { recordValidator })}
      id={id}
      validators={[
        ...(validators || []),
        serverFieldErrMsgWarning(error, () => error && removeError(error), form)
      ]}
      className={classNames(props.className, root)}
      labelClassName={classNames(props.labelClassName, label)}
      showValidationTick={false}
      {...(checkDisabled && { disabled: disableField(id) })}
    />
  );
};

export default TextInput;
